module.exports = __webpack_public_path__ + "static/media/7-2.d97a146f.mp3";